import { BaseSkeleton } from '../../base/skeleton/skeleton';
import styles from './horizontal-event-card-skeleton.module.scss';

export function HorizontalEventCardSkeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.imageBlock}>
        <BaseSkeleton />
      </div>
      <div className={styles.titleBlock}>
        <BaseSkeleton />
      </div>
      <div className={styles.metaBlockWide}>
        <BaseSkeleton />
      </div>
      <div className={styles.metaBlockNarrow}>
        <BaseSkeleton />
      </div>
    </div>
  );
}
